// extracted by mini-css-extract-plugin
module.exports = {"app-container":"App_app-container__RxDqx"};